import { render, staticRenderFns } from "./jhi-navbar.vue?vue&type=template&id=b91ce3a8&scoped=true&"
import script from "./jhi-navbar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./jhi-navbar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./jhi-navbar.vue?vue&type=style&index=0&id=b91ce3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ce3a8",
  null
  
)

export default component.exports